import { render, staticRenderFns } from "./ScoreCalcRule.vue?vue&type=template&id=2ab75b55&"
import script from "./ScoreCalcRule.vue?vue&type=script&lang=js&"
export * from "./ScoreCalcRule.vue?vue&type=script&lang=js&"
import style0 from "./ScoreCalcRule.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports